var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H176C189.255 0 200 10.7452 200 24V196C200 209.255 189.255 220 176 220H24C10.7452 220 0 209.255 0 196V24Z",
    fill: "#D65F83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.5 90C139.404 90 145 84.4036 145 77.5C145 70.5964 139.404 65 132.5 65C125.596 65 120 70.5964 120 77.5C120 84.4036 125.596 90 132.5 90ZM132.5 155C139.404 155 145 149.404 145 142.5C145 135.596 139.404 130 132.5 130C125.596 130 120 135.596 120 142.5C120 149.404 125.596 155 132.5 155ZM80 142.5C80 149.404 74.4036 155 67.5 155C60.5964 155 55 149.404 55 142.5C55 135.596 60.5964 130 67.5 130C74.4036 130 80 135.596 80 142.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5 90C74.4036 90 80 84.4036 80 77.5C80 70.5964 74.4036 65 67.5 65C60.5964 65 55 70.5964 55 77.5C55 84.4036 60.5964 90 67.5 90ZM90 72.5C90 71.1193 91.1193 70 92.5 70H107.5C108.881 70 110 71.1193 110 72.5V77.5C110 78.8807 108.881 80 107.5 80H92.5C91.1193 80 90 78.8807 90 77.5V72.5ZM92.5 140C91.1193 140 90 141.119 90 142.5V147.5C90 148.881 91.1193 150 92.5 150H107.5C108.881 150 110 148.881 110 147.5V142.5C110 141.119 108.881 140 107.5 140H92.5ZM60 102.5C60 101.119 61.1193 100 62.5 100H67.5C68.8807 100 70 101.119 70 102.5V117.5C70 118.881 68.8807 120 67.5 120H62.5C61.1193 120 60 118.881 60 117.5V102.5ZM132.5 100C131.119 100 130 101.119 130 102.5V117.5C130 118.881 131.119 120 132.5 120H137.5C138.881 120 140 118.881 140 117.5V102.5C140 101.119 138.881 100 137.5 100H132.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/dao.132daad7.svg";
export { ForwardRef as ReactComponent };